export enum AdminUsersListColumns {
  'ID' = 'ID',
  'CREATED_DATE' = 'Created Date',
  'NAME' = 'Name',
  'EMAIL' = 'Email',
  'STATUS' = 'Status'
}
export const REGEN_FOR_FORMATTED_TITLE = /([a-z])([A-Z])/g
export const ROW_STYLE = 'flex flex-row justify-between mt-5'
export const COL_STYLE = 'flex flex-col space-y-3 w-3/6'

export const ADMIN_USER_MORE_MENU_ITEMS = {
  EDIT: 'Edit Users Permissions',
  SUSPEND: 'Suspend User',
  DELETE: 'Delete User'
} as const

export const ADMIN_USER_MORE_MENU_ITEMS_FOR_SUSPENDED = {
  EDIT: 'Edit Users Permissions',
  ACTIVATE: 'Activate User',
  DELETE: 'Delete User'
} as const

export const ADMIN_USER_DETAILS_TABS_INDEX = {
  PERMISSIONS: 0
}
export const ADMIN_USER_DETAILS_TABS = ['Permissions']
export const ADMIN_USER_DETAILS_LEFT_CARD_ITEMS = {
  CreatedAtUTC: 'Created Date',
  Email: 'Email'
}
export const DETAILS_CARD_LAST_INDEX = 1
export const ADMIN_USER_FORM_TEXT = {
  EDIT: {
    TITLE: 'Edit Admin User',
    BTN_LABEL: 'Update User Information',
    DIALOG_TITLE: 'User Account Information',
    DIALOG_MSG:
      'Any modification made to the users email, may result in affecting the access to the Dashboard.'
  },
  CREATE: {
    TITLE: 'New Admin User',
    BTN_LABEL: 'Create Admin User',
    DIALOG_TITLE: 'User Account Information',
    DIALOG_MSG:
      'An email will be sent to the user with a temporary password to access the dashboard. User will have access to all sections once the account is created.'
  }
}
export const ADMIN_USER_FORM_FIELDS = {
  NAME: {
    ID: 'name',
    LABEL: 'Admin User Name',
    PLACEHOLDER: 'Name'
  },
  EMAIL: {
    ID: 'email',
    LABEL: 'Admin User Email',
    PLACEHOLDER: 'Email'
  }
}

export const ADMIN_USER_POP_UP = {
  DELETE: {
    title: 'Delete Admin User',
    action: 'Delete the Admin User',
    description:
      'The user won´t be able to access the Admin Dashboard if the action is confirmed.'
  },
  SUSPEND: {
    title: 'Suspend Admin User',
    action: 'Suspend the Admin User',
    description:
      'The user won´t be able to access the Admin Dashboard if the action is confirmed, and will see an error message when trying to access.'
  },
  EDIT: {
    title: 'Activate Admin User',
    action: 'Activate the Admin User',
    description:
      'The user will regain access to the Admin Dashboard if the action is confirmed.'
  },
  ACTIVATE: {
    title: 'Activate Admin User',
    action: 'Activate the Admin User',
    description:
      'The user will regain access to the Admin Dashboard if the action is confirmed.'
  }
}

export const ADMIN_USER_STATUSES = {
  ACTIVE: 'Active',
  SUSPENDED: 'Suspended'
}
export const ADMIN_USER_STATUS_MAP = {
  [ADMIN_USER_STATUSES.ACTIVE]: {
    borderColor: 'border-green-500',
    bgColor: 'bg-lighter-green',
    color: 'green'
  },
  [ADMIN_USER_STATUSES.SUSPENDED]: {
    borderColor: 'border-red-500',
    bgColor: 'bg-lighter-red',
    color: 'red'
  }
}
export const ADMIN_USERS_FILTER_KEY = 'selectedStatus'

export const ADMIN_USER_PERMISSION_SECTIONS = {
  PUBLIC_SECTION: 'PublicSection',
  TENANTS: 'TenantsSection',
  PROVIDER: 'ProvidersSection',
  UPDATE_CARDS: 'UpdateCardsSection',
  USERS: 'UsersSection',
  SEGMENTS: 'SegmentsSection',
  CAMPAIGNS: 'CampaignsSection',
  CAMPAIGN_CATEGORIES: 'CampaignCategoriesSection',
  CATALOG: 'CatalogSection',
  ACHIEVEMENTS: 'AchievementsSection',
  BEHAVIORS: 'BehaviorsSection',
  OFFERS: 'OffersSection',
  OFFER_CATEGORIES: 'OfferCategoriesSection',
  ANNOUNCEMENTS: 'AnnouncementsSection',
  INVOICES: 'InvoicesSection',
  POINT_DISTRIBUTIONS: 'PointDistributionsSection',
  FEATURE_FLAGS: 'FeatureFlagsSection',
  ADMIN_USERS: 'AdminUsersSection',
  UTILITIES: 'UtilitiesSection',
  ACTION_BOXES: 'ActionBoxesSection',
  TVD_BUSINESS_SECTION: 'TVDBusinessSection',
  TVD_PROGRAMS_SECTION: 'TVDProgramsSection'
}

export const VIEW_SECTION = 'viewSection'

export const ADMIN_USER_PERMISSIONS_TITLE: AdminUserPermissionsTitle = {
  TenantsSection: {
    sectionName: 'Tenant Information',
    viewSection: '',
    editTenant: 'Edit Information',
    editTranslations: 'Edit Translations'
  },
  ProvidersSection: {
    sectionName: 'Provider',
    viewSection: '',
    editProvider: 'Edit Provider',
    manageSegments: 'Manage Segments',
    editTranslations: 'Edit Translations'
  },
  UpdateCardsSection: {
    sectionName: 'Update Card',
    viewSection: '',
    createUpdateCard: 'Create New',
    editUpdateCard: 'Edit Update Card',
    updateStatus: 'Update Status',
    manageSegments: 'Manage Segments',
    editTranslations: 'Edit Translations'
  },
  UsersSection: {
    sectionName: 'User List',
    viewSection: '',
    suspendUser: 'Suspend and Activate User',
    optOutUser: 'Opt Out User',
    manageSegments: 'Manage Segments'
  },
  SegmentsSection: {
    sectionName: 'Segments',
    viewSection: '',
    createSegment: 'Create New',
    editSegment: 'Edit Segments',
    deleteSegment: 'Delete Segments',
    deleteAvailableCode: 'Delete Available Codes',
    editTranslations: 'Edit Translations'
  },
  CampaignsSection: {
    sectionName: 'Campaign List',
    viewSection: '',
    createCampaign: 'Create New',
    editCampaign: 'Edit Campaigns',
    updateStatus: 'Update Status',
    editNotes: 'Edit Notes',
    manageSegments: 'Manage Segments',
    editTranslations: 'Edit Translations'
  },
  CampaignCategoriesSection: {
    sectionName: 'Campaign Categories',
    viewSection: '',
    createCategory: 'Create New',
    editCategory: 'Edit Category',
    updateUiPosition: 'Update UI Position',
    updateCampaignsUiPosition: 'Update Campaigns UI Position',
    editTranslations: 'Edit Translations'
  },
  CatalogSection: {
    sectionName: 'Catalog',
    viewSection: ''
  },
  AchievementsSection: {
    sectionName: 'Upload Achievements',
    viewSection: '',
    uploadAchievements: 'Upload Achievements'
  },
  BehaviorsSection: {
    sectionName: 'Upload Behaviors',
    viewSection: '',
    uploadBehaviors: 'Upload Behaviors'
  },
  OffersSection: {
    sectionName: 'Offer List',
    viewSection: '',
    createOffer: 'Create New',
    editOffer: 'Edit Offers',
    updateStatus: 'Update Status',
    refundCoupons: 'Refund Coupons',
    addCoupons: 'Add Coupons',
    deleteAvailableCodes: 'Delete Available Codes',
    manageSegments: 'Manage Segments',
    editTranslations: 'Edit Translations'
  },
  OfferCategoriesSection: {
    sectionName: 'Offer Categories',
    viewSection: '',
    createCategory: 'Create New',
    editCategory: 'Edit Category',
    updateUiPosition: 'Update UI Position',
    updateOffersUiPosition: 'Update Offers UI Position',
    editTranslations: 'Edit Translations'
  },
  AnnouncementsSection: {
    sectionName: 'Announcements',
    viewSection: '',
    createAnnouncement: 'Create New',
    editAnnouncement: 'Edit Announcement',
    updateStatus: 'Update Status',
    editTranslations: 'Edit Translations'
  },
  InvoicesSection: {
    sectionName: 'Invoices',
    viewSection: '',
    createInvoice: 'Create New',
    downloadReport: 'Download Report'
  },
  PointDistributionsSection: {
    sectionName: 'Points Distribution',
    viewSection: '',
    createPointDistribution: 'Create New',
    editPointDistribution: 'Edit Distribution',
    cancelAndReschedulePointDistribution: 'Cancel and Reschedule',
    editTranslations: 'Edit Translations'
  },
  FeatureFlagsSection: {
    sectionName: 'Feature Flags',
    viewSection: '',
    editFeatureFlag: 'Edit Feature Flag',
    updateStatus: 'Update Status',
    manageSegments: 'Manage Segments'
  },
  AdminUsersSection: {
    sectionName: 'Admin Users',
    viewSection: '',
    createNewAdminUser: 'Create New',
    editAdminUser: 'Edit User Information',
    editPermissions: 'Edit Permissions',
    deleteAdminUser: 'Delete User',
    suspendAdminUser: 'Suspend and Activate User'
  },
  UtilitiesSection: {
    sectionName: 'Utilities',
    viewSection: '',
    getPhoneNumberValidationCode: 'Get Phone Validation',
    uploadImageToServer: 'Upload Image',
    migratePhoneVerification: 'Migrate Phone Verification'
  },
  ActionBoxesSection: {
    sectionName: 'Action Boxes',
    viewSection: '',
    editActionBoxes: 'Edit Action Boxes',
    createActionBoxes: 'Create Action Boxes'
  },

  TVDBusinessSection: {
    sectionName: 'TVD Business',
    viewSection: '',
    createBusiness: 'Create Business',
    editBusiness: 'Edit Business',
    suspendBusiness: 'Suspend Business'
  },
  TVDProgramsSection: {
    sectionName: 'TVD Programs',
    viewSection: '',
    createProgram: 'Create Program',
    editProgram: 'Edit Program',
    deleteProgram: 'Delete Program'
  }
}

export const PERMISSIONS_DETAIL_VIEW_DESCRIPTION =
  'List of Sections the User has access to, and the allowed actions'

export const UPDATE_PERMISSIONS_TEXT = {
  TITLE: 'Edit Permissions',
  SUB_TITLE: 'User Permissions',
  DESCRIPTION:
    'Select the Sections the user will have access, and then the actions it can do within the section.'
}
export const UPDATE_BTN_LABEL = 'Update'
export const CANCEL_BTN_LABEL = 'Cancel'
export const EDIT = 'EDIT'
export const PERMISSIONS_NAME = 'PermissionName'
export const ADMIN_USER_PERMISSIONS_KEY_NAME = {
  TENANTS: {
    SECTION: 'TenantsSection',
    EDIT_TENANT: 'editTenant',
    EDIT_TRANSLATIONS: 'editTranslations'
  },
  PROVIDERS: {
    SECTION: 'ProvidersSection',
    EDIT_PROVIDER: 'editProvider',
    MANAGE_SEGMENTS: 'manageSegments',
    EDIT_TRANSLATIONS: 'editTranslations'
  },
  UPDATE_CARDS: {
    SECTION: 'UpdateCardsSection',
    CREATE_UPDATE_CARD: 'createUpdateCard',
    EDIT_UPDATE_CARD: 'editUpdateCard',
    UPDATE_STATUS: 'updateStatus',
    MANAGE_SEGMENTS: 'manageSegments',
    EDIT_TRANSLATIONS: 'editTranslations'
  },
  USERS: {
    SECTION: 'UsersSection',
    SUSPEND_USER: 'suspendUser',
    OPT_OUT_USER: 'optOutUser',
    MANAGE_SEGMENTS: 'manageSegments'
  },
  SEGMENTS: {
    SECTION: 'SegmentsSection',
    CREATE_SEGMENT: 'createSegment',
    EDIT_SEGMENT: 'editSegment',
    DELETE_SEGMENT: 'deleteSegment',
    DELETE_AVAILABLE_CODE: 'deleteAvailableCode',
    EDIT_TRANSLATIONS: 'editTranslations'
  },
  CAMPAIGNS: {
    SECTION: 'CampaignsSection',
    CREATE_CAMPAIGN: 'createCampaign',
    EDIT_CAMPAIGN: 'editCampaign',
    UPDATE_STATUS: 'updateStatus',
    EDIT_NOTES: 'editNotes',
    MANAGE_SEGMENTS: 'manageSegments',
    EDIT_TRANSLATIONS: 'editTranslations'
  },
  CAMPAIGN_CATEGORIES: {
    SECTION: 'CampaignCategoriesSection',
    CREATE_CATEGORY: 'createCategory',
    EDIT_CATEGORY: 'editCategory',
    UPDATE_UI_POSITION: 'updateUiPosition',
    UPDATE_CAMPAIGNS_UI_POSITION: 'updateCampaignsUiPosition',
    EDIT_TRANSLATIONS: 'editTranslations'
  },
  ACHIEVEMENTS: {
    SECTION: 'AchievementsSection',
    UPLOAD_ACHIEVEMENTS: 'uploadAchievements'
  },
  BEHAVIORS: {
    SECTION: 'BehaviorsSection',
    UPLOAD_BEHAVIORS: 'uploadBehaviors'
  },
  OFFERS: {
    SECTION: 'OffersSection',
    CREATE_OFFER: 'createOffer',
    EDIT_OFFER: 'editOffer',
    UPDATE_STATUS: 'updateStatus',
    REFUND_COUPONS: 'refundCoupons',
    ADD_COUPONS: 'addCoupons',
    DELETE_AVAILABLE_CODES: 'deleteAvailableCodes',
    MANAGE_SEGMENTS: 'manageSegments',
    EDIT_TRANSLATIONS: 'editTranslations'
  },
  OFFER_CATEGORIES: {
    SECTION: 'OfferCategoriesSection',
    CREATE_CATEGORY: 'createCategory',
    EDIT_CATEGORY: 'editCategory',
    UPDATE_UI_POSITION: 'updateUiPosition',
    UPDATE_OFFERS_UI_POSITION: 'updateOffersUiPosition',
    EDIT_TRANSLATIONS: 'editTranslations'
  },
  ANNOUNCEMENTS: {
    SECTION: 'AnnouncementsSection',
    CREATE_ANNOUNCEMENT: 'createAnnouncement',
    EDIT_ANNOUNCEMENT: 'editAnnouncement',
    UPDATE_STATUS: 'updateStatus',
    EDIT_TRANSLATIONS: 'editTranslations'
  },
  INVOICES: {
    SECTION: 'InvoicesSection',
    CREATE_INVOICE: 'createInvoice',
    DOWNLOAD_REPORT: 'downloadReport'
  },
  POINT_DISTRIBUTIONS: {
    SECTION: 'PointDistributionsSection',
    CREATE_POINT_DISTRIBUTION: 'createPointDistribution',
    EDIT_POINT_DISTRIBUTION: 'editPointDistribution',
    CANCEL_AND_RESCHEDULE_POINT_DISTRIBUTION:
      'cancelAndReschedulePointDistribution',
    EDIT_TRANSLATIONS: 'editTranslations'
  },
  FEATURE_FLAGS: {
    SECTION: 'FeatureFlagsSection',
    EDIT_FEATURE_FLAG: 'editFeatureFlag',
    UPDATE_STATUS: 'updateStatus',
    MANAGE_SEGMENTS: 'manageSegments'
  },
  ADMIN_USERS: {
    SECTION: 'AdminUsersSection',
    CREATE_NEW_ADMIN_USER: 'createNewAdminUser',
    EDIT_ADMIN_USER: 'editAdminUser',
    EDIT_PERMISSIONS: 'editPermissions',
    DELETE_ADMIN_USER: 'deleteAdminUser',
    SUSPEND_ADMIN_USER: 'suspendAdminUser'
  },
  UTILITIES: {
    SECTION: 'UtilitiesSection',
    GET_PHONE_NUMBER_VALIDATION_CODE: 'getPhoneNumberValidationCode',
    UPLOAD_IMAGE_TO_SERVER: 'uploadImageToServer',
    MIGRATE_PHONE_VERIFICATION: 'migratePhoneVerification'
  },
  ACTION_BOXES: {
    SECTION: 'ActionBoxesSection',
    EDIT_ACTION_BOXES: 'editActionBoxes',
    CREATE_ACTION_BOXES: 'createActionBoxes'
  },
  TVD_BUSINESS: {
    SECTION: 'TVDBusinessSection',
    CREATE_PERMISSION: 'createBusiness',
    EDIT_PERMISSION: 'editBusiness',
    SUSPEND_PERMISSION: 'suspendBusiness'
  },
  TVD_PROGRAMS: {
    SECTION: 'TVDProgramsSection',
    CREATE_PROGRAM: 'createProgram',
    EDIT_PROGRAM: 'editProgram',
    DELETE_PROGRAM: 'deleteProgram'
  }
}

export const DEFAULT_ADMIN_USER_PERMISSIONS = {
  TenantsSection: {
    viewSection: false,
    editTenant: false,
    editTranslations: false
  },
  ProvidersSection: {
    viewSection: false,
    editProvider: false,
    manageSegments: false,
    editTranslations: false
  },
  UpdateCardsSection: {
    viewSection: false,
    createUpdateCard: false,
    editUpdateCard: false,
    updateStatus: false,
    manageSegments: false,
    editTranslations: false
  },
  UsersSection: {
    viewSection: false,
    suspendUser: false,
    optOutUser: false,
    manageSegments: false
  },
  SegmentsSection: {
    viewSection: false,
    createSegment: false,
    editSegment: false,
    deleteSegment: false,
    deleteAvailableCode: false,
    editTranslations: false
  },
  CampaignsSection: {
    viewSection: false,
    createCampaign: false,
    editCampaign: false,
    updateStatus: false,
    editNotes: false,
    manageSegments: false,
    editTranslations: false
  },
  CampaignCategoriesSection: {
    viewSection: false,
    createCategory: false,
    editCategory: false,
    updateUiPosition: false,
    updateCampaignsUiPosition: false,
    editTranslations: false
  },
  AchievementsSection: {
    viewSection: false,
    uploadAchievements: false
  },
  BehaviorsSection: {
    viewSection: false,
    uploadBehaviors: false
  },
  OffersSection: {
    viewSection: false,
    createOffer: false,
    editOffer: false,
    updateStatus: false,
    refundCoupons: false,
    addCoupons: false,
    deleteAvailableCodes: false,
    manageSegments: false,
    editTranslations: false
  },
  OfferCategoriesSection: {
    viewSection: false,
    createCategory: false,
    editCategory: false,
    updateUiPosition: false,
    updateOffersUiPosition: false,
    editTranslations: false
  },
  AnnouncementsSection: {
    viewSection: false,
    createAnnouncement: false,
    editAnnouncement: false,
    updateStatus: false,
    editTranslations: false
  },
  InvoicesSection: {
    viewSection: false,
    createInvoice: false,
    downloadReport: false
  },
  PointDistributionsSection: {
    viewSection: false,
    createPointDistribution: false,
    editPointDistribution: false,
    cancelAndReschedulePointDistribution: false,
    editTranslations: false
  },
  FeatureFlagsSection: {
    viewSection: false,
    editFeatureFlag: false,
    updateStatus: false,
    manageSegments: false
  },
  AdminUsersSection: {
    viewSection: false,
    createNewAdminUser: false,
    editAdminUser: false,
    editPermissions: false,
    deleteAdminUser: false,
    suspendAdminUser: false
  },
  UtilitiesSection: {
    viewSection: false,
    getPhoneNumberValidationCode: false,
    uploadImageToServer: false,
    migratePhoneVerification: false
  },
  CatalogSection: {
    viewSection: false
  },
  ActionBoxesSection: {
    viewSection: false,
    editActionBoxes: false,
    createActionBoxes: false
  },
  TVDBusinessSection: {
    viewSection: true,
    createBusiness: true,
    editBusiness: true,
    suspendBusiness: true
  },
  TVDProgramsSection: {
    viewSection: true,
    createProgram: true,
    editProgram: true,
    deleteProgram: true
  }
}

export const ADMIN_USER_STATUS_UPDATE = {
  ACTIVATE: 'Activate User',
  SUSPEND: 'Suspend User',
  DELETE: 'Delete User'
} as const

export const ADMIN_USER_URL_SECTIONS = {
  tenants: ADMIN_USER_PERMISSION_SECTIONS.TENANTS,
  'tenant-settings': ADMIN_USER_PERMISSION_SECTIONS.TENANTS,
  updates: ADMIN_USER_PERMISSION_SECTIONS.UPDATE_CARDS,
  providers: ADMIN_USER_PERMISSION_SECTIONS.PROVIDER,
  'file-search': ADMIN_USER_PERMISSION_SECTIONS.PUBLIC_SECTION,
  users: ADMIN_USER_PERMISSION_SECTIONS.USERS,
  'target-groups': ADMIN_USER_PERMISSION_SECTIONS.SEGMENTS,
  campaigns: ADMIN_USER_PERMISSION_SECTIONS.CAMPAIGNS,
  catalog: ADMIN_USER_PERMISSION_SECTIONS.CATALOG,
  'campaign-categories': ADMIN_USER_PERMISSION_SECTIONS.CAMPAIGN_CATEGORIES,
  achievements: ADMIN_USER_PERMISSION_SECTIONS.ACHIEVEMENTS,
  behaviors: ADMIN_USER_PERMISSION_SECTIONS.BEHAVIORS,
  offers: ADMIN_USER_PERMISSION_SECTIONS.OFFERS,
  'offer-categories': ADMIN_USER_PERMISSION_SECTIONS.OFFER_CATEGORIES,
  announcements: ADMIN_USER_PERMISSION_SECTIONS.ANNOUNCEMENTS,
  invoices: ADMIN_USER_PERMISSION_SECTIONS.INVOICES,
  'points-distribution': ADMIN_USER_PERMISSION_SECTIONS.POINT_DISTRIBUTIONS,
  'feature-flags': ADMIN_USER_PERMISSION_SECTIONS.FEATURE_FLAGS,
  'admin-users': ADMIN_USER_PERMISSION_SECTIONS.ADMIN_USERS,
  utilities: ADMIN_USER_PERMISSION_SECTIONS.UTILITIES,
  'action-boxes': ADMIN_USER_PERMISSION_SECTIONS.ACTION_BOXES,
  'action-box-categories': ADMIN_USER_PERMISSION_SECTIONS.ACTION_BOXES
}

export const ADMIN_USER = 'Admin User'

export enum AdminPermissionNamesEnum {
  ALL_ENABLED = 'ALL_ENABLED',
  ALL_DISABLED = 'ALL_DISABLED',
  VIEW_ONLY = 'VIEW_ONLY',
  CUSTOM = 'CUSTOM'
}

export const PERMISSION_OPTIONS = [
  {
    label: 'All Enabled',
    value: AdminPermissionNamesEnum.ALL_ENABLED
  },
  {
    label: 'All Disabled',
    value: AdminPermissionNamesEnum.ALL_DISABLED
  },
  {
    label: 'View Only',
    value: AdminPermissionNamesEnum.VIEW_ONLY
  },
  {
    label: 'Custom',
    value: AdminPermissionNamesEnum.CUSTOM
  }
]
